/** @flow */

import * as actions from "@modules/shared/constants/actions";
import * as absenceReasonsReducers from "./reducers";
import initialState from "./state";
import type { AbsenceReasonsState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: AbsenceReasonsState = initialState, action: Object): AbsenceReasonsState => {
  const act = {
    [actions.GetAbsenceReasons]: absenceReasonsReducers.onGetAbsenceReasons,
    [actions.GetAbsenceReasonsSuccess]: absenceReasonsReducers.onGetAbsenceReasonsSuccess,
    [actions.GetAbsenceReasonsError]: absenceReasonsReducers.onGetAbsenceReasonsError,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
